<div class="select-container" (clickOutside)="closeDropdown()">
  <div class="custom-select" (click)="toggleDropdown()">
    <div class="select-selected placeholder" *ngIf="selectedOptions.length<=0">
      {{placeholder | translate}}
      <i class="fas fa-chevron-down arrow-icon"></i>
    </div>
    <div class="select-selected" *ngIf="selectedOptions.length>0">
      <div class="selected-option-container" *ngFor="let option of selectedOptions" [ngClass]="{'multi-option':isMultiSelect}">
        <div class="select-icon" *ngIf="option.icon"><i [class]="option.icon"></i></div>
        {{option.label | translate}}
        <div class="multi-cancel" (click)="selectOption(option, $event)" *ngIf="isMultiSelect"><i class="fas fa-xmark"></i></div>
      </div>
      <i class="fas fa-chevron-down arrow-icon"></i>
    </div>
    <div class="select-items" *ngIf="dropdownOpen">
      <div *ngFor="let option of options" 
           (click)="selectOption(option, $event)" 
           [class.selected]="isSelected(option)">
        <input type="checkbox" class="checkbox" [checked]="isSelected(option)" *ngIf="isMultiSelect" />
        <div class="select-icon" *ngIf="option.icon"><i [class]="option.icon"></i></div>
        {{ option.label | translate }}
      </div>
    </div>
  </div>
</div>
